module.exports = __webpack_public_path__ + "static/img/credit-card-gold.62686407.svg";